import { css } from '@emotion/react';

import Stepper from '../../../shared/components/Button/StepperButton';
import { DealProduct, DirectOrderType } from '../types';
import useDealProduct from '../hooks/useDealProduct';
import { useAppSelector } from '../../../shared/store';

const stepper = css`
  .count {
    font-weight: 400;
  }
`;

interface Props {
  dealProduct: DealProduct;
  directOrderType?: DirectOrderType;
  isPC?: boolean;
}

export default function DealProductStepper({ dealProduct, isPC = true }: Props) {
  const { quantity, buyUnit, maxEa, minEa } = dealProduct;
  const { changeQuantity } = useDealProduct(dealProduct);

  const { contentType } = useAppSelector(({ productDetail }) => productDetail);

  const minusDisabled = contentType === 'MULTI' ? quantity <= 0 : quantity <= minEa;

  return (
    <Stepper
      css={stepper}
      count={quantity}
      unit={buyUnit}
      minusDisabled={minusDisabled}
      plusDisabled={quantity > maxEa}
      onChange={changeQuantity}
      isPC={isPC}
    />
  );
}
